import { useState, useEffect } from "react";


interface Breakpoints {
  isXs: boolean;
  isSm: boolean;
  isMd: boolean;
  isLg: boolean;
  isXl: boolean;
}

const useResponsive = (): Breakpoints => {
  const [breakpoints, setBreakpoints] = useState<Breakpoints>({
    isXs: false,
    isSm: false,
    isMd: false,
    isLg: false,
    isXl: false,
  });

  const handleResize = () => {
    const width = window.innerWidth;
    setBreakpoints({
      isXs: width < 576,
      isSm: width >= 576 && width < 768,
      isMd: width >= 768 && width < 992,
      isLg: width >= 992 && width < 1200,
      isXl: width >= 1200,
    });
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return breakpoints;
};

export default useResponsive;
